import { Brand } from "custom-types/Brand";

import { BrandHead } from "components/brands/BrandHead";
import BrandHeader from "components/brands/BrandHeader";

import BrandCrumbs from "../BrandCrumbs";

const BrandLayoutWrapper = ({
  brand,
  isFollowing,
  children,
  categoryName,
}: {
  brand: Brand;
  isFollowing?: boolean;
  children: React.ReactNode;
  categoryName?: string;
}) => {
  return (
    <div className="flex flex-col container justify-center py-5 gap-xl">
      <BrandHead brand={brand} categoryName={categoryName} />
      <BrandHeader brand={brand} isFollowing={isFollowing} />
      {children}
      <BrandCrumbs brandName={brand.name} />
    </div>
  );
};

export default BrandLayoutWrapper;
